/* Site-Specific JavaScript */
jq(document).ready(function () {
    let data_table_headers = document.querySelectorAll('.accordion-header');
    data_table_headers.forEach((el) => {
        el.addEventListener('keydown', (evt) => {
            if (evt.code === 'Enter') {
                el.click();
            }
        });
    });

    var keyWrapperAffixed = jq(".key-wrapper.affixed");
    var subNavEl = jq(".sub-navigation");
    if (keyWrapperAffixed.length) {
        var keyWrapperAffixedOffset = keyWrapperAffixed.offset().top;
        var baseTop = subNavEl.length ? subNavEl.offset().top : keyWrapperAffixedOffset;
        var subNavAndHeaderOffset = baseTop + jq("#header").outerHeight();
        // Fix an issue when the sub nav offset is larger than the window height, would cause the keyWrapper to not affix to the header
        if (subNavAndHeaderOffset >= keyWrapperAffixedOffset) {
            keyWrapperAffixed.affix({
                offset: {
                    top: keyWrapperAffixedOffset + jq("#header").outerHeight() - 63
                }
            });
        } else {
            keyWrapperAffixed.affix({
                offset: {
                    top: baseTop + jq("#header").outerHeight() - 63
                }
            });
        }
    }
    
    // hide cards then 'load' themm on button click for - Regulatory Disclosure page
    jq(".module-load-cards .row--cards .content-box-wrapper:nth-of-type(1n + 10)").addClass("card--hidden");
    jq(".module-load-cards .row--cards").after("<div class='center'><a class='btn btn--display-hidden-cards'>Load More</a></div>");
    jq(".btn--display-hidden-cards").click(function(){
        jq(".module-load-cards .row--cards .content-box-wrapper").removeClass("card--hidden");
        jq(".btn--display-hidden-cards").hide();
    });
    // IR CTA Home Slider
    jq('.module-news-blocks-carousel .news-blocks').each(function(){
        jq(this).slick({
            mobileFirst: true,
            slidesToShow: 1,
            adaptiveHeight: true,
            autoplay: false,
            autoplaySpeed: 4000,
            arrows: true,
            dots: false,
            appendArrows: jq('.col--slide-nav'),
            prevArrow: '<div class="prev prev-arrow slide-arrow"><span class="material-symbols-outlined">arrow_back_ios</span></div>',
            nextArrow: '<div class="next next-arrow slide-arrow"><span class="material-symbols-outlined">arrow_forward_ios</span></div>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
            ]
        });
    });
    // Submit button outside search form to submit search on press release pg.
    jq('#pr_search_submit').click(function() {
        jq('#pr_search_form').submit();
    });
    jq(".report .outerFootnotes").parent().attr("colspan", "4");
    
    // Report footer fix for balance sheet.
    jq(".report .outerFootnotes").parent().attr("colspan", "4");
    // Update height on carousel
    jq('.module-news-blocks-carousel').on('click', '.slick-arrow', function () {
        jq.fn.matchHeight._update();
    })

    if (jq('#pr-search').length) {
        // Scroll to hash
        var windowLocationHash = window.location.hash;
        if (windowLocationHash.length) {
            var hashElement = jq(windowLocationHash);
            if (hashElement.length) {
                var offset = 0;
                var header = jq('#header');
                var subNav = jq('#sub-navigation');
                if (header.length) {
                    offset += header.outerHeight();
                }
                if (subNav.length) {
                    offset += subNav.outerHeight();
                }
                console.log(offset);
                jq('html,body').animate({
                    
                  scrollTop: jq('.newsroom-article-list').offset().top - offset
                }, 600);
            }  
        }
    }
    
    jq("#leave-page").click(function (e) {
       alert("You are now leaving the Huntington website.");
    });
        // Dividends page, set 1 second delay then add in text, helps remove wave error on page table
    setTimeout( function() {
        jq(".page-type-qmod---dividends .qmod-control.qmod-th-0.control.sorting_disabled").append("Dividends");
    }, 1000);
    
    // A news grid that filters in place opts out of the global redirect-select
    // handler, so its year select submits the form it sits in instead
    jq(".news-grid-filters--in-place select").on("change", function () {
        jq(this).closest("form").submit();
    });

    // Add elements to table wrappers for mobile styling
    jq('.table-figure').each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        
        wrap.prepend('<span class="left-shadow-block"></span>');
        wrap.append('<span class="right-shadow-block"></span>');

    });

});